import { Component, OnInit, EventEmitter, Output } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { ConfigService } from '../../../../../core/services/config.service';

import { OrganizationDetailsService } from '../../organization-details.service';

@Component({
	selector: 'itpx-update-print-logo',
	templateUrl: './update-print-logo.component.html',
	styleUrls: ['./update-print-logo.component.css']
})
export class UpdatePrintLogoComponent implements OnInit {

	private cancelRoute: string = '/organization/organization-details';
	private component: string = 'agoraprint';
	private saveRoute: string = '/organization/organization-details';
	private allowedTypes = ['jpeg', 'png', 'bmp'];  
	private imgSrc: string;
	private details: any;
	private id: string;
	private sub: Subscription;
	private defaultImage: string;
	private bucket: string = this.configService.get('aws').uploadsBucket;

	@Output() unsavedDataUploader = new EventEmitter();

	constructor(
		private service: OrganizationDetailsService,
		private configService: ConfigService,
		private route: ActivatedRoute,
		private router: Router
	) {
		this.defaultImage = this.configService.get('images').defaultImage;
	}

	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
				this.id = params['id'];
				this.service.getDetails(this.id)
					.subscribe(
						body => {
							this.details = <any>body['data'];
							if(this.details.printLogo == null || this.details.printLogo.length == 0) {
								this.imgSrc = '';
							} else  {
								this.imgSrc = this.details.printLogo;
							}
						}
					);
		});
	}

	private unsavedData(e: any) {
		this.unsavedDataUploader.emit(true);
	}

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/update-print-logo/update-print-logo.component.ts